import PropTypes from 'prop-types'
import React from 'react'
import { css as glamorCss } from 'glamor'
import glamorous from 'glamorous'
import {
  Button,
  Badge,
  Checkbox,
  HeadingText,
  Link,
} from '@paypalcorp/pp-react'
import DocumentTitle from 'react-document-title'
import { connect } from '../utils/p2p-connect'
import { post } from '../../calculator/lib/xhr'
import { css } from 'lib/paypalphrodite'
import styles from './funding-option-selector.styles'
import StaggerGroup from './staggerGroup'
import FundingSource from './funding-source'
import DisallowedFundingSource from './disallowed-funding-source'
import PreferredLegalScroll from './preferred-legal-scroll'
import {
  NO_ADD_CARD_VARIANTS,
  CONTINGENCY,
  INSTRUMENT_TYPES,
} from '../../../../lib/constants'
import Overpanel from 'react-components/overpanel'
import {
  formatSourceId,
  getFundingSourceName,
  getRelevantFundingSource,
  getPreferredFundingSource,
  getPartialBalanceSourcesFromOption,
  getAllPartialBalanceSourcesFromOptions,
  buildBalanceToggleDisplayName,
  getRelevantOptionsByPartialBalances,
  getCounterpartFundingOption,
  isPayPalBalanceOnlyOption,
  isOptionWithPair,
  getPrimarySourceFromOption,
  getOptionById,
  getFundingNameType,
} from '../utils/funding-option-utils'
import { extractRTBContingency } from '../../../../lib/utils/openBankingSharedUtils'
import { routeTo, back } from '../utils/routeHelper'
import { getFlowType } from '../utils/url-utils'
import { uniq, flattenDeep, isEmpty, get } from 'lodash'
import * as viewActions from '../actions/Actions'
import * as overpanelActions from '../actions/overpanels'
import * as sendActions from '../actions/send'
import { trackImpression, trackLinkWithData } from '../../lib/analytics/fpti'
import { tracking } from '../../lib/analytics/mParticle'
import Events, { commonProps } from '../../lib/analytics/eventTags'
import { trackCashAdvanceFeesClick } from '../utils/cash-advance-fees-analytics'

import * as authUtils from '../../lib/authUtils'
import { OPEN_BANKING_FLOWS, FLOW_TYPES } from '../constants'
import { extract3DS2Contingency } from '../utils/3ds-utils'
import content from 'pp-react-l10n'
import { getFILinkName, generateFIFlowUrl } from '../../experiments/fiFlow'
import { isIframe } from 'iframe-support'
import CIPOverpanels from './nobalance/cip-overpanels'
import OpenBankingOverpanel from './open-banking/openBankingOverpanel'
import { isOpenBankingTreatment } from '../../experiments/openBanking'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { hasAddFiPostMigration } from '../../experiments/migrateRoutes'
import CashAdvanceFeesOverpanels from './cash-advance-fees-overpanel'
import OpenBankingWarning from './open-banking/openBankingWarning'
import serverProps from '../utils/serverProps'
import { trackOpenBankingAction } from '../utils/openBankingAnalytics'
import { getTrafficSource } from '../utils/mgmUtils'
import ButtonLink from 'react-components/buttonLink'
import { mobileAndSmaller } from 'lib/styles/media-queries'

let i18n = content('transfer/fundingOptionsSelector')

const Heading = glamorous.h2({
  margin: '0px auto 2rem',
})

const ShowMoreButton = glamorous.button({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  outline: 'inherit',
  float: 'right',
})

const AddCardButton = glamorous.button({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  outline: 'inherit',
  float: 'left',
})

const BackLinkWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '20px auto 0',
})

const BalanceToggleDiv = glamorous.div(
  {
    padding: '0 3px',
    '& label': {
      marginBottom: 0,
    },
  },
  ({ isDisabled = false }) => {
    return {
      '& label': {
        opacity: isDisabled ? 0.3 : 1,
      },
    }
  }
)

const NextButtonWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '24px 0',
})

export class FundingOptionSelector extends React.Component {
  static propTypes = {
    hasAddedCard: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    isRenderedInOverpanel: PropTypes.bool,
    handleCloseAsOverpanel: PropTypes.func,
    fundingOptions: PropTypes.array,
    disallowedSources: PropTypes.array,
    selectedFundingOption: PropTypes.object,
    isPurchase: PropTypes.bool,
    shouldHideWrapperBorder: PropTypes.bool,
    shouldHideBackButton: PropTypes.bool,
    shouldHideAddCard: PropTypes.bool,
    requestId: PropTypes.string,
    requestLegId: PropTypes.string,
    isPreferredSourceDisallowed: PropTypes.bool,
    userAgreementLinkUrl: PropTypes.string.isRequired,
    overpanelIsOpen: PropTypes.bool,
    isRTL: PropTypes.bool,
    unified: PropTypes.bool,
    token: PropTypes.string,
    payerId: PropTypes.string,
    recipient: PropTypes.string,
    displayName: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    unilateralName: PropTypes.string,
    unilateralCountryCode: PropTypes.string,
    networkId: PropTypes.string,
    moneyPageOverPanel: PropTypes.string,
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
    cipStatus: PropTypes.string,
    isCFPBEnabledCountry: PropTypes.bool,
    userAccountType: PropTypes.string,
    isCardArtEnabled: PropTypes.bool,
    showPreferredCheckbox: PropTypes.bool,
    successfullyAddedFundingInstrumentIds: PropTypes.string,
    showCashAdvanceFeesOverpanel: PropTypes.bool,
    pStudioContent: PropTypes.object,
    unavailableFI: PropTypes.bool,
    mayCashAdvanceFeesApply: PropTypes.bool,
    fromCurrencyCode: PropTypes.string,
    noteLength: PropTypes.number,
    recipientCountry: PropTypes.string,
    recipientAccountType: PropTypes.string,
    hasBalance: PropTypes.bool,
    isCrowdFundingCampaign: PropTypes.bool,
    fundingOptionsData: PropTypes.object,
    fundingOptionIdFromSession: PropTypes.string,
    isOpenBankingReconsentFlow: PropTypes.bool,
    isAddBankFlow: PropTypes.bool,
    isOpenBankingAbandonment: PropTypes.bool,
    openBankingError: PropTypes.string,
    accountType: PropTypes.string,
    flowIntent: PropTypes.string,
    env: PropTypes.string,
    isPSAEnabled: PropTypes.bool,
    note: PropTypes.string,
    isFirstFeeFreeEligible: PropTypes.bool,
  }

  static defaultProps = {
    isRenderedInOverpanel: false,
    ddcCalls: [],
    payerId: '',
    displayName: '',
    thumbnailUrl: '',
  }

  state = {
    showOnlyThreeFundingOptions: true,
    showPreferredLegalScroll: false,
    balanceToggleIsChecked: false,
    selectedFundingOption: {},
    setPreferredId: '',
  }

  componentWillMount() {
    const {
      unified,
      currencyCode,
      fromCurrencyCode,
      noteLength,
      recipientCountry,
      recipientAccountType,
      isPurchase,
      hasBalance,
      isCrowdFundingCampaign = false,
      overpanelIsOpen,
      fundingOptionIdFromSession,
      isOpenBankingReconsentFlow,
      isRenderedInOverpanel,
      isOpenBankingAbandonment,
      openBankingError,
    } = this.props
    this.unified = unified
    const unifiedString = this.unified ? 'unified:' : ''
    this.analyticsStrings = {
      pageGroup: `main:p2p:${unifiedString}choice:fioption`,
      pageName: `main:p2p:${unifiedString}choice:fioption::node`,
    }

    let { selectedFundingOption, fundingOptions } = this.props
    const optionAlreadySelected = !!selectedFundingOption.id
    const fallbackOption = fundingOptions[0] || {}
    selectedFundingOption = optionAlreadySelected
      ? selectedFundingOption
      : fallbackOption
    const partialBalanceSourceIds = getPartialBalanceSourcesFromOption(
      selectedFundingOption
    ).map(source => source.id)
    const sortedFundingOptions = this.buildSortedFundingOptions(fundingOptions)

    // Count the number of FIs that have cash advance fees as returned from the service
    const numOfCashAdvFeeAppliesFI =
      fundingOptions &&
      fundingOptions.filter(
        option =>
          option.funding_sources &&
          option.funding_sources[0] &&
          option.funding_sources[0].cashAdvanceFeeApplies === true
      ).length

    const dflFmxId = () => {
      const selectedFOExists = !!Object.keys(selectedFundingOption).length
      return (
        selectedFOExists &&
        selectedFundingOption.funding_sources.map(source => source.id)
      )
    }

    const usingPreferred = () => {
      const selectedFOExists = !!Object.keys(selectedFundingOption).length
      const answer =
        selectedFOExists &&
        selectedFundingOption.funding_sources.some(source => source.isPreferred)
      return answer ? 'Y' : 'N'
    }

    const relevantFundingOptions = getRelevantOptionsByPartialBalances(
      sortedFundingOptions,
      []
    )
    let ofr_fmxid = relevantFundingOptions.map(source =>
      source.funding_sources.map(fs => fs.id)
    )
    ofr_fmxid = [].concat(...ofr_fmxid)

    const fundingSource = getRelevantFundingSource(selectedFundingOption) || {}
    const sourceName = getFundingSourceName(fundingSource)

    const fundingOptionNames =
      Array.isArray(fundingOptions) &&
      fundingOptions.map(source => {
        const currentRelevantSource = getRelevantFundingSource(source)
        return getFundingSourceName(currentRelevantSource)
      })

    const threeDS2Contingency = extract3DS2Contingency(selectedFundingOption)
    const has3DS2Contingency = !isEmpty(threeDS2Contingency)

    const threeDS2ReferenceId = has3DS2Contingency
      ? threeDS2Contingency.three_ds_reference_id
      : ''

    let rtbContingency = extractRTBContingency(selectedFundingOption).action
    if (rtbContingency === CONTINGENCY.INVALID_CREDENTIALS) {
      rtbContingency = CONTINGENCY.REFRESH
    }

    const data = {
      fltp: isPurchase ? 'g&s' : 'f&f',
      dfl_fmxid: dflFmxId() || 'nodefault',
      is_pref: usingPreferred(),
      ofr_fmxid: ofr_fmxid.toString() || '',
      is_3ds_eligible: has3DS2Contingency,
      '3ds_ref_id': threeDS2ReferenceId,
      av_fmx_tp: fundingOptionNames,
      sel_fmx_tp: sourceName,
      eligible_fi_cnt: numOfCashAdvFeeAppliesFI,
      chosen_fi_id: fundingSource.id,
      contingency_return: rtbContingency || 'none',
      ...(isCrowdFundingCampaign && { flow: FLOW_TYPES.CROWD_FUNDING }),
    }

    // if the overpanel is showing or we are on the component itself
    const { pageGroup, pageName } = this.analyticsStrings
    if (overpanelIsOpen || !isRenderedInOverpanel) {
      trackImpression(pageGroup, pageName, data)
      tracking(
        Events.p2p_fi_screen_shown({
          balance_available: hasBalance ? 'y' : 'n',
          receiver_country: recipientCountry,
          payment_type: isPurchase ? 'purchase' : 'personal',
          receiver_currency: currencyCode,
          fi_eligible_count: numOfCashAdvFeeAppliesFI,
          note_character_length: noteLength,
          sender_currency: fromCurrencyCode,
          receiver_account_type: recipientAccountType,
          default_fi: Array.isArray(data.dfl_fmxid)
            ? data.dfl_fmxid[0]
            : data.dfl_fmxid,
        })
      )
    }

    this.setState(
      {
        sortedFundingOptions,
        selectedFundingOption,
        balanceToggleMap: this.buildBalanceToggleMap(partialBalanceSourceIds),
      },
      () => {
        tracking({
          ...commonProps,
          ...this.analyticsStrings,
          ...this.getAnalyticsObject(),
          event_name: 'p2p_fi_selector_set_state_callback_called',
          event_type: 'ac',
        })
        // Resolve CONSENT contingency after WALLET login flow
        if (
          selectedFundingOption.hasRTBContingency &&
          selectedFundingOption.id === fundingOptionIdFromSession &&
          isOpenBankingReconsentFlow &&
          !isOpenBankingAbandonment
        ) {
          this.resolveRTBContingencies(
            isOpenBankingReconsentFlow,
            openBankingError
          )
        }
      }
    )
  }

  componentWillReceiveProps(nextProps) {
    const { ...prevProps } = this.props
    const { successfullyAddedFundingInstrumentIds, fundingOptions } = nextProps

    // if successfullyAddedFundingInstrumentIds is a csv of FI Ids and fundingOptions has at least one element,
    // we pre-select the first FI of fundingOptions Array
    if (
      successfullyAddedFundingInstrumentIds &&
      successfullyAddedFundingInstrumentIds.includes(',') &&
      fundingOptions.length
    ) {
      this.props.dispatch(
        viewActions.changeSelectedFundingOption(fundingOptions[0].id, {})
      )
      const partialBalanceSourceIds = getPartialBalanceSourcesFromOption(
        fundingOptions[0]
      ).map(source => source.id)

      this.setState({
        selectedFundingOption: fundingOptions[0],
        balanceToggleMap: this.buildBalanceToggleMap(
          partialBalanceSourceIds,
          fundingOptions
        ),
      })
    }

    // if we just added card, be sure to show all option in case the card option is positioned low in response
    const justAddedCard = !prevProps.hasAddedCard && nextProps.hasAddedCard
    if (justAddedCard) {
      this.setState({
        showOnlyThreeFundingOptions: !justAddedCard,
      })
    }

    // we may have added card, or some other edge case where options change but this selector is open
    if (prevProps.fundingOptions !== nextProps.fundingOptions) {
      const partialBalanceSourceIds = getPartialBalanceSourcesFromOption(
        nextProps.selectedFundingOption
      ).map(source => source.id)
      this.setState({
        sortedFundingOptions: this.buildSortedFundingOptions(
          nextProps.fundingOptions
        ),
        selectedFundingOption: nextProps.selectedFundingOption,
        balanceToggleMap: this.buildBalanceToggleMap(partialBalanceSourceIds),
        setPreferredId: '',
      })
    }
  }

  componentWillUnmount() {
    /**
     * This removes the funding source id previously saved in homepage-external-redirect
     *  by simply saving an empty string, so that when componentDidUpdate is executed in the preview component,
     *  the successId is empty and it does not execute a code block that would cause a loop.
     */
    this.props.dispatch(
      sendActions.saveSuccessfullyAddedFundingInstrumentIds('')
    )

    const { unavailableFI } = this.props
    // This removes the Unavailable FI warning so it doesn't render more than once after this component is unmounted.
    if (unavailableFI) {
      this.props.dispatch(sendActions.toggleFIUnavailableWarning(false))
    }
  }

  /**
   * We need to store each partial balance toggle that is clicked in state. This util analyzes a list of funding options
   * and returns map with a sourceId -> isChecked scheme. The initial map might look something like:
   * {
   *   HO3DJ4: false, // the USD balance in a split plan
   *   HO5SS3: false, // the EUR balance .. .. ..
   *   HO8LE4: false, // the MXN balance .. .. ..
   * }
   * @param {}
   * @return {}
   */
  buildBalanceToggleMap = (
    partialBalanceIdsToToggle = [],
    externalFundingOptions = []
  ) => {
    const fundingOptions = externalFundingOptions.length
      ? externalFundingOptions
      : this.props.fundingOptions

    return getAllPartialBalanceSourcesFromOptions(fundingOptions).reduce(
      (map, source) => {
        map[source.id] = partialBalanceIdsToToggle.includes(source.id)
        return map
      },
      {}
    )
  }

  getListFromBalanceToggleMap = balanceToggleMap => {
    return Object.keys(balanceToggleMap).filter(
      srcId => balanceToggleMap[srcId]
    )
  }

  /**
   * Method which takes the funding options list as provided by the services (which has meaningful ordering), and sorts
   * it to be more conducive to our mapping. Because we filter out plans which don't apply based on partial balances that
   * have been toggled, we need the order of options with a particular primary source to never change.
   */
  buildSortedFundingOptions = fundingOptions => {
    let sortedFundingOptions = []

    // get options which contain solely primary sources (CC, Bank, Balance (single or multi), Credit)
    // IMPORTANT: this order is how we're contractually obligated to display options TODO absolutely push services to provide this data explicitly instead of tribal knowledge
    const primaryOptions = fundingOptions.filter(
      option =>
        isPayPalBalanceOnlyOption(option) || option.funding_sources.length === 1
    )

    primaryOptions.forEach(primaryOption => {
      // we don't search for any balance only options permutations with partial applied, because that wouldn't happen
      if (isPayPalBalanceOnlyOption(primaryOption)) {
        return sortedFundingOptions.push(primaryOption)
      }

      // get a list of all the options which include the sole source id within primaryOption
      const targetSourceId = primaryOption.funding_sources[0].id
      const permutationsOfPrimaryOption = fundingOptions.filter(
        ({ funding_sources }) => {
          return funding_sources.some(source => {
            return source.id === targetSourceId
          })
        }
      )

      // add that list to our growing sortedFundingOptions
      sortedFundingOptions = sortedFundingOptions.concat(
        permutationsOfPrimaryOption
      )
    })

    // RISK RULE CAVEAT: if for some reason there are plans where risk has denied the use of the card/bank on it's own,
    // but allowed it to be split with balance, we need to make sure those end up in the list of sorted options. (I know...)
    fundingOptions.forEach(targetOption => {
      // if paypal balance option only
      if (isPayPalBalanceOnlyOption(targetOption)) {
        return
      }

      const { id: primarySourceId } = getPrimarySourceFromOption(targetOption)
      const targetPrimarySourceIds = primaryOptions
        .filter(option => !isPayPalBalanceOnlyOption(option))
        .map(option => option.funding_sources[0].id)
      if (!targetPrimarySourceIds.includes(primarySourceId)) {
        sortedFundingOptions.push(targetOption)
      }
    })

    return sortedFundingOptions
  }

  shouldShowBalanceToggle = () => {
    const partialBalanceOptionsExist = !!getAllPartialBalanceSourcesFromOptions(
      this.props.fundingOptions
    ).length
    return partialBalanceOptionsExist
  }

  buildPayRequestPreviewRoute = (requestId, requestLegId) => {
    return `/payRequest/${requestId}/${requestLegId}`
  }

  buildSendBuyPreviewRoute = isPurchase => {
    const flow = isPurchase ? 'buy' : 'send'
    if (this.unified) {
      return `/homepage/${flow}/preview`
    }
    return `/${flow}/preview`
  }

  /**
   * Helper that allows us accepts a partial balance source (represented in UI as checkbox), and searches to see if it
   * should be clickable given the current state of selection. 1. is this ID one of the currently selected sources 2.
   * is this ID in any option along with the currently selected IDs (should it be clickable in the future)
   */
  shouldDisableBalanceToggle = partialBalanceSource => {
    const {
      sortedFundingOptions,
      selectedFundingOption,
      balanceToggleMap,
    } = this.state
    const {
      funding_sources: selectedFundingSources = [],
    } = selectedFundingOption

    const selectedSourceIds = selectedFundingSources.map(source => source.id)
    const toggledPartialBalanceSourceIds = this.getListFromBalanceToggleMap(
      balanceToggleMap
    )
    const targetIds = uniq([
      ...selectedSourceIds,
      ...toggledPartialBalanceSourceIds,
      partialBalanceSource.id,
    ])

    if (isPayPalBalanceOnlyOption(selectedFundingOption)) {
      // if any balance ONLY option is selected, then we can never also add a partial balance source
      return true
    }

    const fundingOptionsSansBalanceOnly = sortedFundingOptions.filter(
      option => !isPayPalBalanceOnlyOption(option)
    )
    // TODO swap this out for getOptionBySourceIds in utils (seems like it would just work - too scared under current time line)
    const shouldBeClickable = fundingOptionsSansBalanceOnly.some(
      ({ funding_sources = [] }) => {
        // is there some option
        return targetIds.every(targetId => {
          // ... where all the target ids
          return funding_sources.some(({ id = '' }) => {
            // ... are present within
            return id === targetId
          })
        })
      }
    )

    return !shouldBeClickable
  }

  togglePreferredLegalScrollOverpanel = () => {
    this.setState({
      showPreferredLegalScroll: !this.state.showPreferredLegalScroll,
    })
  }

  resolveRTBContingencies = (
    isOpenBankingReconsentFlow = false,
    base64EncodedJWTErrorFromWallet
  ) => {
    const {
      successfullyAddedFundingInstrumentIds,
      fundingOptions,
      dispatch,
    } = this.props

    const { selectedFundingOption } = this.state
    const hasSelectedFundingOption = !!selectedFundingOption.id

    tracking({
      ...commonProps,
      ...this.analyticsStrings,
      ...this.getAnalyticsObject(),
      event_name: 'p2p_fi_selector_resolve_contingency_called',
      event_type: 'ac',
    })

    // When calling resolve contingency on componentDidUpdate there is no selected funding option
    // in that case, it has to be searched by the successfullyAddedFundingInstrumentIds from wallet redirection
    const fundingOption = hasSelectedFundingOption
      ? selectedFundingOption
      : getOptionById(fundingOptions, successfullyAddedFundingInstrumentIds)

    const rtbContingency = extractRTBContingency(fundingOption).action
    if (
      rtbContingency === CONTINGENCY.REFRESH ||
      (isOpenBankingReconsentFlow &&
        (rtbContingency === CONTINGENCY.INVALID_CREDENTIALS ||
          rtbContingency === CONTINGENCY.CONSENT))
    ) {
      dispatch(
        sendActions.resolveRTBContingency(
          rtbContingency,
          this.handleNextButton,
          fundingOption.id,
          base64EncodedJWTErrorFromWallet,
          status => {
            trackOpenBankingAction({
              ...this.analyticsStrings,
              ...this.getAnalyticsObject(),
              ...(!status
                ? {
                    event_name: 'p2p_fi_contingency_called',
                  }
                : {
                    event_name: 'p2p_fi_contingency_resolved',
                    status,
                  }),
            })
          }
        )
      )
    } else if (
      rtbContingency === CONTINGENCY.CONSENT ||
      rtbContingency === CONTINGENCY.INVALID_CREDENTIALS
    ) {
      dispatch(overpanelActions.toggleOpenBankingOverpanel({ show: true }))
      // Don't resolve the contingency if it should display Open Banking overpanel.
    }
  }

  handleAddCard = addFILinkName => {
    const analyticsData = this.getAnalyticsObject()
    const { pageGroup, pageName } = this.analyticsStrings
    trackLinkWithData(addFILinkName, pageGroup, pageName, analyticsData, 'link')
    tracking(Events.p2p_fi_add_pressed())
    const mainWindow = isIframe() ? window.top : window
    const fiFlowPayload = {
      flowType: getFlowType(),
      amount: this.props.amount,
      currencyCode: this.props.currencyCode,
      payerId: this.props.payerId,
      recipient: this.props.recipient,
      displayName: this.props.displayName,
      thumbnailUrl: this.props.thumbnailUrl,
      networkId: this.props.networkId,
      obFlow: OPEN_BANKING_FLOWS.ADD_BANK,
      unilateralName: this.props.unilateralName,
      unilateralCountryCode: this.props.unilateralCountryCode,
      mayCashAdvanceFeesApply: this.props.mayCashAdvanceFeesApply,
      isPurchase: this.props.isPurchase,
      mgmTrafficSource: getTrafficSource(),
      flowIntent: this.props.flowIntent,
      env: this.props.env,
      note: this.props.note,
      isFirstFeeFreeEligible: this.props.isFirstFeeFreeEligible,
      token: this.props.token,
    }

    const fiFlowUrl = generateFIFlowUrl(fiFlowPayload)
    const fiNewUrl = '/myaccount/transfer/flow/fi/new'
    if (hasAddFiPostMigration()) {
      post(fiNewUrl, fiFlowPayload)
        .then(response => {
          const { redirectURL = {} } = response
          mainWindow.location.assign(redirectURL)
        })
        .catch(err => {
          return this.props.dispatch(viewActions.showError(err))
        })
    } else {
      mainWindow.location.assign(fiFlowUrl)
    }
  }

  handleNextButton = clickThru => {
    let analyticsData = this.getAnalyticsObject()

    const {
      selectedFundingOption: { id },
      setPreferredId,
      selectedFundingOption,
    } = this.state

    const {
      requestId,
      requestLegId,
      isPurchase,
      pStudioContent,
      recipientAccountType,
      recipientCountry,
      fromCurrencyCode,
      currencyCode,
      noteLength,
      hasBalance,
    } = this.props

    const shouldResolveRTBContingency =
      isOpenBankingTreatment() && selectedFundingOption.hasRTBContingency

    const dflFmxId =
      (!!Object.keys(selectedFundingOption).length &&
        selectedFundingOption.funding_sources.map(source => source.id)) ||
      'nodefault'

    tracking(
      Events.p2p_fi_next_pressed({
        ...getFundingNameType(selectedFundingOption),
        fi_id: id,
        fi_selected: id,
        receiver_country: recipientCountry,
        payment_type: isPurchase ? 'purchase' : 'personal',
        receiver_currency: currencyCode,
        note_character_length: noteLength,
        balance_toggle: hasBalance ? 'y' : 'n',
        sender_currency: fromCurrencyCode,
        receiver_account_type: recipientAccountType,
        default_fi: Array.isArray(dflFmxId) ? dflFmxId[0] : dflFmxId,
      })
    )

    // CASH ADVANCE FEE LOGIC
    const { funding_sources } = this.state.selectedFundingOption
    const hasCashAdvanceFees = funding_sources.some(
      source => source.cashAdvanceFeeApplies === true
    )

    // NOTE: The touchpoint content will only refresh on a reload.
    //       IF the daily impression count is 5 they COULD see the disclosure
    //       MORE than 5 times per session, because we the content is sourced
    //       on App LOAD.
    //
    // TODO: This is something that we should rethink and call personalization
    //       studio for content when we need it ...
    const maxImpressionReached = get(
      pStudioContent,
      'p2p_cash_advance_fees_disclosure_touchpoint.noContent204',
      false
    )

    // Check and show the cash advance fees interstitial ALWAYS unless max impression has been reached
    if (clickThru === 'cashadvancefee-override-pglk') {
      analyticsData.pglk = 'main:p2p:unified:cashadvancedisclaimer|continue'
    } else if (
      !this.props.isPurchase &&
      hasCashAdvanceFees &&
      !maxImpressionReached
    ) {
      this.props.dispatch(
        overpanelActions.toggleCashAdvanceFeesOverpanel({
          show: true,
          selectedFundingOption: this.state.selectedFundingOption,
          type: 'ACTIONS',
        })
      )
      return
    }

    if (shouldResolveRTBContingency) {
      this.resolveRTBContingencies()
      return
    }

    this.props.dispatch(
      viewActions.changeSelectedFundingOption(id, analyticsData)
    )

    if (setPreferredId) {
      this.props.dispatch(sendActions.setPreferredFundingSource(setPreferredId))
    }

    if (this.props.isRenderedInOverpanel) {
      /*
       * NOTE: This is where funding option selector is rendered in an overpanel.
       *       Before cash advance fees all that was need to was close the overpanel,
       *       now there are two overpanels open and we need to close both at the
       *       same time!  In order for the overpanels to close and unfreeze the under-
       *       lying main content, you have to insure the dispatch finished executing so
       *       that the overpanelCount is updated before closing the next one.  If it is
       *       not updated then the main content will be left 'frozen' and unscrollable.
       *       Using a setTimeout() with 500ms will insure that redux count is updated.
       */

      this.props.dispatch(
        overpanelActions.toggleFundingOptionsOverpanel({ show: false })
      )

      if (this.props.showCashAdvanceFeesOverpanel) {
        setTimeout(() => {
          this.props.dispatch(
            overpanelActions.toggleCashAdvanceFeesOverpanel({
              show: false,
              selectedFundingOption: this.state.selectedFundingOption,
              type: 'ACTIONS',
            })
          )
        }, 500)
      }
      return
    }

    // TODO do this more simply, can we just .replace the current url somehow and handle all cases (does this break portable, where we can't know urls)
    const previewRoute = requestId
      ? this.buildPayRequestPreviewRoute(requestId, requestLegId)
      : this.buildSendBuyPreviewRoute(isPurchase)
    routeTo(previewRoute)
  }

  getAnalyticsObject = () => {
    const { selectedFundingOption = {}, setPreferredId } = this.state
    const {
      fundingOptions,
      isPurchase,
      successfullyAddedFundingInstrumentIds,
      fundingOptionIdFromSession,
      isOpenBankingReconsentFlow,
      isOpenBankingAbandonment,
      openBankingError,
    } = this.props
    const selectedFOExists = !!Object.keys(selectedFundingOption).length
    const usingPreferred = () => {
      let preferredSources = {}

      if (selectedFOExists) {
        preferredSources = selectedFundingOption.funding_sources.find(
          source => {
            return setPreferredId === source.id || source.isPreferred
          }
        )
      }
      return preferredSources
    }

    const usePreferred = usingPreferred()

    let preferred = usePreferred ||
      getPreferredFundingSource(fundingOptions) || { id: '' }
    const dflFmxId =
      selectedFOExists &&
      selectedFundingOption.funding_sources.map(source => source.id)
    const sortedFundingOptions = this.buildSortedFundingOptions(fundingOptions)
    const relevantFundingOptions = getRelevantOptionsByPartialBalances(
      sortedFundingOptions,
      []
    )
    const cashAdvInlineWarn =
      selectedFOExists &&
      selectedFundingOption.funding_sources.some(
        source => source.cashAdvanceFeeApplies === true
      )

    const dfl_fmxid = dflFmxId ? dflFmxId.toString() : 'nodefault'
    const fltp = isPurchase ? 'g&s' : 'f&f'
    const pref_fmxid = preferred.id || 'notset'
    const is_pref = usePreferred ? 'Y' : 'N'
    const ofr_fmxid =
      flattenDeep(
        relevantFundingOptions.map(source =>
          source.funding_sources.map(fs => fs.id)
        )
      ).toString() || ''

    const fundingSource = getRelevantFundingSource(selectedFundingOption) || {}
    const sourceName = getFundingSourceName(fundingSource)

    const threeDS2Contingency = extract3DS2Contingency(selectedFundingOption)
    const has3DS2Contingency = !isEmpty(threeDS2Contingency)
    const threeDS2ReferenceId = has3DS2Contingency
      ? threeDS2Contingency.three_ds_reference_id
      : ''

    let rtbContingency = extractRTBContingency(selectedFundingOption).action
    if (rtbContingency === CONTINGENCY.INVALID_CREDENTIALS) {
      rtbContingency = CONTINGENCY.REFRESH
    }

    return {
      fltp,
      dfl_fmxid,
      pref_fmxid,
      is_pref,
      ofr_fmxid,
      flfr: 'choice',
      message_shown: cashAdvInlineWarn ? 'y' : 'n',
      is_3ds_eligible: has3DS2Contingency,
      '3ds_ref_id': threeDS2ReferenceId,
      sel_fmx_tp: sourceName,
      chosen_fi_id: fundingSource.id,
      contingency_return: rtbContingency || 'none',
      chosen_fo_id: selectedFundingOption.id,
      fundingOptionIdFromSession,
      hasRTBContingency: selectedFundingOption.hasRTBContingency,
      isOpenBankingReconsentFlow,
      isOpenBankingAbandonment,
      isOpenBankingTreatment: isOpenBankingTreatment(),
      successfullyAddedFundingInstrumentIds,
      openBankingError,
      raw_contingency_return: extractRTBContingency(selectedFundingOption)
        .action,
    }
  }

  handleBackButton = () => {
    tracking(Events.p2p_fi_back_pressed())
    if (this.props.isRenderedInOverpanel) {
      // don't route anywhere, just close the overpanel
      return this.props.dispatch(
        overpanelActions.toggleFundingOptionsOverpanel({ show: false })
      )
    }

    // we must be in the interstitial, we want to go back to preview as it was - without any funding options,
    this.props.dispatch(sendActions.clearFundingOptions())
    back()
  }

  handleFundingOptionChange = fundingOption => {
    const {
      setPreferredId,
      balanceToggleMap: currentBalanceToggleMap,
      sortedFundingOptions,
    } = this.state
    const { funding_sources } = fundingOption

    // if a user has selected a funding option which cannot be split, we must clear any toggle which may have been set
    const shouldResetBalanceToggleMap = !isOptionWithPair(
      fundingOption,
      sortedFundingOptions
    )

    // if the new option doesn't include the preferred source id we must clear it
    const shouldClearSetPreferredId = !funding_sources.some(
      source => source.id === setPreferredId
    )

    const hasCashAdvanceFees = funding_sources.some(
      source => source.cashAdvanceFeeApplies === true
    )

    const { pageGroup, pageName } = this.analyticsStrings
    tracking(
      Events.p2p_fi_selection_pressed({
        fi_selection_switched: 'y',
        fi_warning_type: hasCashAdvanceFees ? 'cash_advance' : '',
      })
    )

    this.setState(
      {
        selectedFundingOption: fundingOption,
        balanceToggleMap: shouldResetBalanceToggleMap
          ? this.buildBalanceToggleMap()
          : currentBalanceToggleMap,
        setPreferredId: shouldClearSetPreferredId ? '' : setPreferredId,
      },
      () => {
        /**
         *  We need to track this data after setState is excecuted.
         *  getAnalyticsObject uses selectedFundingOption from the components state
         */
        const analyticsData = this.getAnalyticsObject()
        trackLinkWithData(
          'changeFI',
          pageGroup,
          pageName,
          analyticsData,
          'link'
        )
      }
    )
  }

  handlePreferredCheckboxChange = newId => {
    if (authUtils.isOneTouchUser()) {
      this.props.dispatch(authUtils.requestLoginAction())
      return
    }

    const savedId = this.state.setPreferredId
    // because we're using a CHECKBOX to store string data, unchecking will still pass same id we have stored so we need to manually clear
    const shouldClearState = savedId === newId
    this.setState({
      setPreferredId: shouldClearState ? '' : newId,
    })
  }

  handleBalanceToggle = id => {
    const {
      sortedFundingOptions,
      selectedFundingOption,
      balanceToggleMap,
    } = this.state
    const newBalanceToggleMap = {
      ...balanceToggleMap,
      [id]: !balanceToggleMap[id],
    }
    const toggledPartialBalanceSourceIds = this.getListFromBalanceToggleMap(
      newBalanceToggleMap
    )
    const relevantFundingOptions = getRelevantOptionsByPartialBalances(
      sortedFundingOptions,
      toggledPartialBalanceSourceIds
    )
    this.setState({
      balanceToggleMap: newBalanceToggleMap,
      selectedFundingOption: getCounterpartFundingOption(
        selectedFundingOption,
        relevantFundingOptions
      ),
    })
  }

  handleShowMore = event => {
    event.preventDefault()
    this.setState({
      showOnlyThreeFundingOptions: false,
    })
  }

  handleShowCashAdvanceFeeOverpanel = (analytic = 'inlineMoreInfo') => {
    event.preventDefault()
    tracking(
      Events.p2p_fi_selection_warning_pressed({
        fi_warning_type: 'cash_advance',
      })
    )
    trackCashAdvanceFeesClick(analytic)
    this.props.dispatch(
      overpanelActions.toggleCashAdvanceFeesOverpanel({
        show: true,
        type: 'ABOUT',
        selectedFundingOption: this.state.selectedFundingOption,
      })
    )
  }

  handleOpenBankingAgreeButton = () => {
    const { selectedFundingOption } = this.state
    const fundingSource = getRelevantFundingSource(selectedFundingOption)
    const fundingSourceId = formatSourceId(fundingSource.id) // requires dash

    this.props.dispatch(
      sendActions.redirectToBankLogin({
        flowType: getFlowType(),
        amount: this.props.amount,
        currencyCode: this.props.currencyCode,
        payerId: this.props.payerId,
        recipient: this.props.recipient,
        fundingSourceId,
        fundingOptionId: selectedFundingOption.id,
        fundingOptionsData: {
          ...this.props.fundingOptionsData,
          selectedFundingOptionId: selectedFundingOption.id,
        },
        obFlow: OPEN_BANKING_FLOWS.CONSENT_CONTINGENCY,
        unilateralName: this.props.unilateralName,
        unilateralCountryCode: this.props.unilateralCountryCode,
        displayName: this.props.displayName,
        thumbnailUrl: this.props.thumbnailUrl,
        networkId: this.props.networkId,
        mgmTrafficSource: getTrafficSource(),
        isPurchase: this.props.isPurchase,
        flowIntent: this.props.flowIntent,
        env: this.props.env,
        token: this.props.token,
      })
    )
  }

  renderSpacer = height => {
    return <hr className={css(styles.dynamicSpacer)} style={{ height }} />
  }

  renderPreferredBadge = () => {
    return (
      <div className={css(styles.preferredBadge)}>
        <p
          className={`vx_text-6_lighter ${css(
            styles.preferredBadgeText,
            styles.preventIncorrectLabelWrap
          )}`}
        >
          {i18n('preferred')}
        </p>
      </div>
    )
  }

  renderBalanceToggle = partialBalanceSource => {
    const { isPreferred, id } = partialBalanceSource
    const { balanceToggleMap } = this.state
    const isChecked = balanceToggleMap[id]
    const isDisabled = this.shouldDisableBalanceToggle(partialBalanceSource)

    return isDw2Repaint() ? (
      <BalanceToggleDiv isDisabled={isDisabled} key={id}>
        <Checkbox
          id={`H-toggle-${id}`}
          onChange={() => this.handleBalanceToggle(id)}
          checked={isChecked}
          disabled={isDisabled}
          label={buildBalanceToggleDisplayName(
            partialBalanceSource,
            this.props.isCFPBEnabledCountry,
            this.props.userAccountType
          )}
          helperText={
            isPreferred && (
              <Badge style={{ marginTop: '0.25rem' }} type="feature">
                {i18n('badge.preferred')}
              </Badge>
            )
          }
        ></Checkbox>
      </BalanceToggleDiv>
    ) : (
      <div
        key={id}
        className={`vx_checkbox ${css(
          styles.balanceToggleWrapper,
          isDisabled && styles.greyedOut
        )}`}
      >
        <input
          onChange={() => this.handleBalanceToggle(id)}
          type="checkbox"
          id={`H-toggle-${id}`}
          checked={isChecked}
          disabled={isDisabled}
        />
        <label
          className={css(styles.balanceCheckbox, styles.forceDisplayBlock)}
          htmlFor={`H-toggle-${id}`}
        >
          <span className={css(styles.preventIncorrectLabelWrap)}>
            {buildBalanceToggleDisplayName(
              partialBalanceSource,
              this.props.isCFPBEnabledCountry,
              this.props.userAccountType
            )}
          </span>
        </label>
        {isPreferred && this.renderPreferredBadge()}
      </div>
    )
  }

  renderFundingOptionAlert = () => {
    return (
      <div
        className={`vx_alert vx_alert-help ${css(
          styles.fundingOptionAlertWrapper
        )}`}
      >
        <p className="vx_alert-text">{i18n('alert.preferredDisallowed')}</p>
      </div>
    )
  }

  renderUnavailableFIWarning = () => {
    const { isAddBankFlow, accountType, fundingOptions } = this.props
    const paymentMethodDisabledContentKey =
      fundingOptions.length > 0
        ? 'warning.OB.paymentMethodDisabled'
        : 'warning.OB.paymentMethodDisabledNoFIs'
    const contentKey = isAddBankFlow
      ? 'warning.OB.paymentMethodUnavailable'
      : paymentMethodDisabledContentKey

    return (
      <OpenBankingWarning
        accountType={accountType}
        contentKey={contentKey}
        style={{
          marginBottom: '20px', // same as <hr/> element that separates the FIs
        }}
      />
    )
  }

  renderInformationalFees = () => {
    return (
      <div className={`${css(styles.inlineWarningContainer)}`}>
        <p className={`ppvx_text--sm ${css(styles.inlineWarningBlurb)}`}>
          {i18n('warning.inline.text')}
        </p>
        <button
          className={`vx_btn-link ppvx_text--sm ppvx_text--medium ${css(
            styles.inlineWarningInfoLink
          )}`}
          onClick={() => this.handleShowCashAdvanceFeeOverpanel('moreInfo')}
        >
          {i18n('warning.inline.link')}
        </button>
      </div>
    )
  }

  // Removes CIP HOLDING source since we handle this via it's own CIP flow
  getFilteredDisallowedSources = () => {
    const { disallowedSources } = this.props
    return disallowedSources.filter(
      source =>
        source.instrument_type !== INSTRUMENT_TYPES.HOLDING &&
        source.reason !== 'CIP_REQUIRED'
    )
  }

  render() {
    const {
      isRTL,
      isPurchase,
      fundingOptions,
      userAccountType,
      isCardArtEnabled,
      isCFPBEnabledCountry,
      showPreferredCheckbox,
      isPreferredSourceDisallowed,
      pStudioContent,
      unavailableFI,
      disallowedSources,
    } = this.props
    const areNoFundingOptions = fundingOptions.length === 0
    const hasDisallowedSources = disallowedSources.length > 0
    // TODO: Check if the following if statement can be removed
    if (areNoFundingOptions && !hasDisallowedSources) {
      return null
    }

    const showDisallowedError = isPreferredSourceDisallowed
    const {
      selectedFundingOption,
      showOnlyThreeFundingOptions,
      showPreferredLegalScroll,
      setPreferredId,
      balanceToggleMap,
      sortedFundingOptions,
    } = this.state
    const selectedFundingOptionExists = !!selectedFundingOption.funding_sources
    const wrapperClassName = css(
      this.props.isRenderedInOverpanel && styles.overpanelWrapper,
      !this.props.isRenderedInOverpanel && styles.pageWrapper,
      this.props.shouldHideWrapperBorder && styles.noBorder
    )
    const partialBalanceSourceIds = Object.keys(balanceToggleMap).filter(
      srcId => balanceToggleMap[srcId]
    )
    const relevantFundingOptions = getRelevantOptionsByPartialBalances(
      sortedFundingOptions,
      partialBalanceSourceIds
    )

    // we need to check if the selected fundting option has cash advance fees,
    // IF it does we renderInformationalFees, if it does not then we dont' show it.
    const { funding_sources = [] } = selectedFundingOption
    const selectedFundingOptionHasCashAdvanceFees = funding_sources.some(
      source => source.cashAdvanceFeeApplies === true
    )
    // special content from personalization studio
    const pContent = get(
      pStudioContent,
      'p2p_cash_advance_fees_inline_warning_touchpoint.content.json',
      {}
    )
    const lengthLimit = showOnlyThreeFundingOptions ? 3 : undefined // undefined is equivalent to having no upper bound
    const disableNextButton = !selectedFundingOptionExists

    const addFILinkName = getFILinkName(getFlowType())
    const filteredDisallowedSources = this.getFilteredDisallowedSources()

    let { shouldHideAddCard } = this.props

    if (!shouldHideAddCard) {
      shouldHideAddCard = NO_ADD_CARD_VARIANTS.includes(
        this.props.moneyPageOverPanel
      )
    }

    return (
      <DocumentTitle title={i18n('a11y.title')}>
        <div className={css(styles.fundingOptionsWrapper)}>
          <div className={wrapperClassName}>
            <form>
              <fieldset>
                <legend className={css(styles.headerWrapper)}>
                  {isDw2Repaint() ? (
                    <HeadingText size="sm" as={Heading}>
                      {i18n('howToPay')}
                    </HeadingText>
                  ) : (
                    <h2 className={css(styles.header)}>{i18n('howToPay')}</h2>
                  )}
                </legend>
                {unavailableFI && this.renderUnavailableFIWarning()}
                {showDisallowedError && this.renderFundingOptionAlert()}
                {showDisallowedError &&
                  this.shouldShowBalanceToggle() &&
                  this.renderSpacer(20)}
                {getAllPartialBalanceSourcesFromOptions(
                  sortedFundingOptions
                ).map(this.renderBalanceToggle)}
                {(showDisallowedError || this.shouldShowBalanceToggle()) &&
                  (isDw2Repaint()
                    ? this.renderSpacer(16)
                    : this.renderSpacer(50))}
                <ul className={css(styles.fundingOptionsListWrapper)}>
                  <hr
                    className={css(
                      styles.lineSeparator,
                      styles.topLineSeparator
                    )}
                  />
                  <StaggerGroup
                    interval={130}
                    beforeClassName={css(styles.staggerBefore)}
                    afterClassName={css(styles.staggerAfter)}
                  >
                    {relevantFundingOptions
                      .slice(0, lengthLimit)
                      .map((fundingOption, i) => {
                        return (
                          <FundingSource
                            getAnalyticsObject={this.getAnalyticsObject}
                            key={fundingOption.id}
                            index={i}
                            isRTL={isRTL}
                            fundingOption={fundingOption}
                            isSelected={
                              fundingOption.id === selectedFundingOption.id
                            }
                            isPurchase={isPurchase}
                            setPreferredId={setPreferredId}
                            handlePreferredCheckboxChange={
                              this.handlePreferredCheckboxChange
                            }
                            handleSelect={this.handleFundingOptionChange}
                            togglePreferredLegalScrollOverpanel={
                              this.togglePreferredLegalScrollOverpanel
                            }
                            isCFPBEnabledCountry={isCFPBEnabledCountry}
                            userAccountType={userAccountType}
                            isCardArtEnabled={isCardArtEnabled}
                            showPreferredCheckbox={showPreferredCheckbox}
                            cashAdvanceWarningContent={pContent}
                            warningLabelOnClick={
                              this.handleShowCashAdvanceFeeOverpanel
                            }
                          />
                        )
                      })}
                    {filteredDisallowedSources.map((fundingOption, i) => {
                      return (
                        <DisallowedFundingSource
                          key={'disallowed-' + i}
                          index={i}
                          isRTL={isRTL}
                          fundingOption={fundingOption}
                          isCFPBEnabledCountry={isCFPBEnabledCountry}
                          userAccountType={userAccountType}
                          isCardArtEnabled={isCardArtEnabled}
                        />
                      )
                    })}
                  </StaggerGroup>
                </ul>

                {relevantFundingOptions.length > 3 &&
                  showOnlyThreeFundingOptions &&
                  (isDw2Repaint() ? (
                    // eslint-disable-next-line consumerweb/require-pagename
                    <Link as={ShowMoreButton} onClick={this.handleShowMore}>
                      {i18n('button.showMore')}
                    </Link>
                  ) : (
                    <button
                      onClick={this.handleShowMore}
                      className={`${css(styles.showMoreCards)} vx_btn-link`}
                    >
                      {i18n('button.showMore')}
                    </button>
                  ))}

                {!shouldHideAddCard &&
                  (isDw2Repaint() ? (
                    // eslint-disable-next-line consumerweb/require-pagename
                    <Link
                      as={AddCardButton}
                      onClick={() => {
                        this.handleAddCard(addFILinkName)
                      }}
                      type="button"
                      data-nemo="add-new-card"
                    >
                      {i18n(`button.${addFILinkName}`)}
                    </Link>
                  ) : (
                    <button
                      onClick={() => {
                        this.handleAddCard(addFILinkName)
                      }}
                      type="button"
                      data-nemo="add-new-card"
                      className={`${css(styles.newCardLink)} vx_btn-link`}
                    >
                      {i18n(`button.${addFILinkName}`)}
                    </button>
                  ))}
              </fieldset>
            </form>
          </div>

          {!this.props.isPurchase &&
            selectedFundingOptionHasCashAdvanceFees &&
            this.renderInformationalFees()}

          {isDw2Repaint() ? (
            <NextButtonWrapper>
              {/* $FlowFixMe */}
              <Button
                // $FlowFixMe
                className={glamorCss({
                  ...(disableNextButton && {
                    color: '#cbd2d6',
                    background: '#f5f6f8',
                    boxShadow: 'none',
                    border: '1px solid #cbd2d6',
                    textDecoration: 'none',
                    cursor: 'not-allowed',
                    outline: 'none',
                    transform: 'none',
                    ':after': {
                      content: 'none',
                    },
                  }),
                  [mobileAndSmaller]: {
                    width: '100%',
                    margin: '0 16px',
                  },
                }).toString()}
                data-nemo="choice-next-button"
                onClick={this.handleNextButton}
                disabled={disableNextButton}
              >
                {i18n('button.next')}
              </Button>
            </NextButtonWrapper>
          ) : (
            <button
              data-nemo="choice-next-button"
              onClick={this.handleNextButton}
              className={`${css(styles.nextButton)} vx_btn`}
              disabled={disableNextButton}
            >
              {i18n('button.next')}
            </button>
          )}

          {!this.props.shouldHideBackButton &&
            (isDw2Repaint() ? (
              <BackLinkWrapper>
                <ButtonLink
                  data="unit-test-back-button"
                  onClick={this.handleBackButton}
                >
                  {i18n('button.back')}
                </ButtonLink>
              </BackLinkWrapper>
            ) : (
              <button
                data="unit-test-back-button"
                onClick={this.handleBackButton}
                className={`${css(styles.cancelButton)} vx_btn-link`}
              >
                {i18n('button.back')}
              </button>
            ))}

          <Overpanel
            show={showPreferredLegalScroll}
            handleClose={this.togglePreferredLegalScrollOverpanel}
          >
            <PreferredLegalScroll
              userAgreementLinkUrl={this.props.userAgreementLinkUrl}
              handleCloseButton={this.togglePreferredLegalScrollOverpanel}
              isPSAEnabled={this.props.isPSAEnabled}
            />
          </Overpanel>

          <CIPOverpanels cipStatus={this.props.cipStatus} />
          {isOpenBankingTreatment() && (
            <OpenBankingOverpanel
              selectedFundingOption={this.state.selectedFundingOption}
              handleNext={this.handleOpenBankingAgreeButton}
            />
          )}
          <CashAdvanceFeesOverpanels handleNext={this.handleNextButton} />
        </div>
      </DocumentTitle>
    )
  }
}

export default connect(
  ({
    transaction,
    server,
    overpanels,
    card,
    recipient,
    amount,
    external,
    unilateral,
    crossBorder,
    note,
  }) => ({
    hasAddedCard: card.addedCards.length > 0,
    requestId: server.requestId,
    requestLegId: server.requestLegId,
    shouldHideWrapperBorder: server.env === 'ppme' || server.env === 'pools',
    shouldHideBackButton: !!(
      server.env === 'ppme' ||
      server.env === 'pools' ||
      (server.requestId && server.requestLegId)
    ) /* last one is when it is a pay-request flow */,
    shouldHideAddCard: server.env === 'pisp' && !external.addCardSupported,
    successfullyAddedFundingInstrumentIds:
      transaction.successfullyAddedFundingInstrumentIds,
    selectedFundingOption: transaction.selectedFundingOption,
    fundingOptions: transaction.fundingOptions,
    // Used for Open Banking reconsent flow.
    fundingOptionsData: {
      fundingOptions: transaction.fundingOptions,
      disallowedSources: transaction.disallowedSources,
      complianceInfo: transaction.complianceInfo,
      isPaypalAccount: recipient.isPaypalAccount,
      additionalDisclosureActions: transaction.additionalDisclosureActions,
      xbActualRecipientCountry: crossBorder.xbActualRecipientCountry,
      xbChosenCountry: crossBorder.xbChosenCountry,
      xbCountryMismatch: crossBorder.xbCountryMismatch,
      isCrowdFundingCampaign: transaction.isCrowdFundingCampaign,
      riskHoldOverpanelVariant: transaction.riskHoldOverpanelVariant,
      isPreferredSourceDisallowed: transaction.isPreferredSourceDisallowed,
      conversionType: transaction.conversionType,
      showFISelector: transaction.showFISelector,
    },
    disallowedSources: transaction.disallowedSources,
    isPurchase: transaction.isPurchase,
    isCrowdFundingCampaign: transaction.isCrowdFundingCampaign,
    currencySeparator: transaction.currencySeparator,
    isPreferredSourceDisallowed: transaction.isPreferredSourceDisallowed,
    mayCashAdvanceFeesApply:
      crossBorder.fromCurrencyCode === 'USD' &&
      crossBorder.toCurrencyCode === 'USD' &&
      !transaction.isPurchase,
    userAgreementLinkUrl: server.userAgreementLinkUrl,
    overpanelIsOpen: overpanels.fundingOptionsOverpanel,
    token: recipient.token,
    payerId: recipient.payerId,
    recipient: recipient.recipient,
    displayName: recipient.displayName,
    thumbnailUrl: recipient.thumbnailUrl,
    networkId: recipient.networkId,
    moneyPageOverPanel: recipient.moneyPageOverPanel,
    recipientCountry: recipient.country,
    recipientAccountType: recipient.recipientAccountType,
    amount: amount.amount,
    note: note.note,
    currencyCode: amount.currencyCode,
    fromCurrencyCode: amount.fromCurrencyCode,
    cipStatus: external.cipStatus,
    isRTL: server.directionality === 'rtl',
    isCFPBEnabledCountry: server.isCFPBEnabledCountry,
    userAccountType: server.userAccountType,
    isCardArtEnabled: server.features && server.features.isCardArtEnabled,
    showPreferredCheckbox: server.groupFeatures.showPreferredCheckbox,
    unilateralName: unilateral.name,
    unilateralCountryCode: unilateral.countryCode,
    unavailableFI: transaction.unavailableFI,
    accountType: transaction.accountType,
    pStudioContent: server.pStudioContent,
    showCashAdvanceFeesOverpanel: overpanels.showCashAdvanceFeesOverpanel,
    showGenericAboutCashAdvanceFeesOverpanel:
      overpanels.showGenericAboutCashAdvanceFeesOverpanel,
    cashAdvanceFeesOverpanelContentType:
      overpanels.cashAdvanceFeesOverpanelContentType,
    noteLength: note.note.length,
    hasBalance: get(server, 'userConfig.features.balance'),
    isOpenBankingReconsentFlow:
      isOpenBankingTreatment() &&
      serverProps.obFlow === OPEN_BANKING_FLOWS.CONSENT_CONTINGENCY,
    fundingOptionIdFromSession: get(
      serverProps,
      'fundingOptionsData.selectedFundingOptionId',
      ''
    ),
    isAddBankFlow: serverProps.obFlow === OPEN_BANKING_FLOWS.ADD_BANK,
    isOpenBankingAbandonment: !(
      transaction.openBankingError ||
      transaction.successfullyAddedFundingInstrumentIds
    ),
    openBankingError: transaction.openBankingError,
    flowIntent: server.flowIntent,
    env: server.env,
    isPSAEnabled: server.isPSAEnabled,
    isFirstFeeFreeEligible: transaction.isFirstFeeFreeEligible,
  })
)(FundingOptionSelector)
